import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { customerShipmentsList } from "../../actions/shipmentNPayment";
import Table from "../../common/Table";
import { NavWrap, TableWrap } from "../ShopForTyres";

import { ship_status_text } from "./ShipmentDetails";
import json2csv from "json2csv";
import { saveAs } from "file-saver";
import { DownloadOutlined } from "@ant-design/icons";

const Shipments = () => {
  const dispatch = useDispatch();
  const shipment_list = useSelector(
    (state) => state?.shipNPay?.customer_shipments_list
  );
  const history = useHistory();
  const [dates, setDates] = useState({});
  const [filters, setFilters] = useState({
    ship_status: 3,
  });
  const location = useLocation();
  const [tableScroll, setTableScroll] = useState({ x: "100%" });

  useEffect(() => {
    const screenWidth = window.screen.width;
    const newScroll = screenWidth > 2200 ? { x: "100%" } : { x: 2200 };
    setTableScroll(newScroll);
  }, []);
  useEffect(() => {
    let fils = location?.state?.filters ? location?.state?.filters : filters;
    if (location?.state?.filters) {
      setFilters(fils);
      history.replace("/track-shipments");
    }
    if (dates.start_date && dates.end_date) {
      dispatch(
        customerShipmentsList({
          email: localStorage.getItem("email"),
          ...dates,
          ...fils,
        })
      );
    } else {
      if (!dates.start_date && !dates.end_date) {
        if (fils.ship_status === 3) {
          dispatch(
            customerShipmentsList({
              email: localStorage.getItem("email"),
            })
          );
        } else
          dispatch(
            customerShipmentsList({
              email: localStorage.getItem("email"),
              ...fils,
            })
          );
      }
    }
    // eslint-disable-next-line
  }, [dates]);
  const Preshipstatus = {
    A: "Approved",
    S: "Auto Approved",
    P: "Pending Approval",
  };
  const columns = [
    // {
    //   header: "DO Number",
    //   accessor: "DeliveryNo",
    //   width: 8,
    // },
    {
      header: "Shipment ID",
      accessor: "ShipNo",
      width: 10,
    },
    {
      header: "Sales Order",
      accessor: "Sostring",
      width: 17,
    },
    {
      header: "Customer PO",
      accessor: "Custpostring",
      width: 17,
    },
    {
      header: "Delivered Quantity",
      accessor: "DeliveredQty",
      width: 10,
      cell: (row) => <span>{parseInt(row.DeliveredQty)}</span>,
    },
    {
      header: "Fill",
      accessor: "ZfillTot",
      width: 8,
      cell: (row) => <span>{parseFloat(row.ZfillTot).toFixed(3)}</span>,
    },
    {
      header: "ETD",
      accessor: "EtdDate",
      width: 8,
      cell: (row) => (
        <span>
          {row.EtdDate && !row.EtdDate?.includes("0000")
            ? moment(row.EtdDate, "YYYYMMDD").format("MM/DD/YY")
            : "-"}
        </span>
      ),
    },
    {
      header: "ETA",
      accessor: "EtaDate",
      width: 8,
      cell: (row) => (
        <span>
          {row.EtaDate && !row.EtaDate?.includes("0000")
            ? moment(row.EtaDate, "YYYYMMDD").format("MM/DD/YY")
            : "-"}
        </span>
      ),
    },
    {
      header: "Pre-shipment advice",
      accessor: "Preshipstatus",
      width: 15,
      cell: (row) => (
        <span className="text-btn">{Preshipstatus[row.Preshipstatus]}</span>
      ),
      className: "psa_status",
    },
    {
      header: "Order Type",
      accessor: "Vtweg",
      width: 7,
      cell: (row) => (row.Vtweg === "41" ? "FTL" : "FD"),
      className: "psa_status",
    },
    {
      header: "Shipment Status",
      accessor: "ShipStatus",
      width: 10,
      cell: (row) => (
        <span className="success-text">
          {ship_status_text[row.ShipStatus] || "Planning"}
        </span>
      ),
    },
    {
      header: "Shipment Origin",
      accessor: "Werkscrtyname",
      width: 10,
    },
    {
      header: "Delivery Address",
      accessor: "Street",
      width: 12,
      cell: (row) => (
        <span>
          {row.Street}, {row.City1}, {row.Country}
        </span>
      ),
    },
    {
      header: "Container No",
      accessor: "Container",
      width: 10,
    },
    {
      header: "Vessel Name",
      accessor: "VesselNo",
      width: 10,
    },
  ];

  return (
    <div className="shop-tyres">
      <NavWrap>
        <TableWrap
          isFilter={false}
          showBulk={false}
          name={`Shipments ${
            Array.isArray(shipment_list?.data)
              ? filters.ship_status === 3
                ? `(${
                    shipment_list?.data?.filter(
                      // eslint-disable-next-line
                      (ele) =>
                        ele?.Preshipstatus === "P" &&
                        ele?.Vtweg === "42" &&
                        ele?.ShipNo
                    )?.length
                  })`
                : `(${shipment_list?.data?.length})`
              : ""
          }`}
          showGrid={false}
          searchPlaceholder={"Search by Sales Order..."}
          namedFilters={[
            {
              label: "Pending Actions",
              action: () => {
                let obj = {
                  email: localStorage.getItem("email"),
                  search_key: filters?.search_key,
                };
                if (dates.end_date && dates.start_date) {
                  obj = { ...obj, ...dates };
                }
                setFilters((f) => ({
                  ...f,
                  ship_status: 3,
                }));
                dispatch(customerShipmentsList(obj));
              },
              isActive: filters.ship_status === 3,
            },
            {
              label: "Planned Shipments",
              action: () => {
                let obj = {
                  email: localStorage.getItem("email"),
                  ship_status: 0,
                  search_key: filters?.search_key,
                };
                if (dates.end_date && dates.start_date) {
                  obj = { ...obj, ...dates };
                }
                setFilters((f) => ({
                  ...f,
                  ship_status: 0,
                }));
                dispatch(customerShipmentsList(obj));
              },
              isActive: filters.ship_status === 0,
            },
            {
              label: "In-Transit",
              action: () => {
                let obj = {
                  email: localStorage.getItem("email"),
                  ship_status: 2,
                  search_key: filters?.search_key,
                };
                if (dates.end_date && dates.start_date) {
                  obj = { ...obj, ...dates };
                }
                setFilters((f) => ({
                  ...f,
                  ship_status: 2,
                }));
                dispatch(customerShipmentsList(obj));
              },
              isActive: filters.ship_status === 2,
            },
            {
              label: "Completed",
              action: () => {
                let obj = {
                  email: localStorage.getItem("email"),
                  ship_status: 5,
                  search_key: filters?.search_key,
                };
                if (dates.end_date && dates.start_date) {
                  obj = { ...obj, ...dates };
                }
                setFilters((f) => ({
                  ...f,
                  ship_status: 5,
                }));
                dispatch(customerShipmentsList(obj));
              },
              isActive: filters.ship_status === 5,
            },
            {
              label: "All ",
              action: () => {
                let obj = {
                  email: localStorage.getItem("email"),
                  ...filters,
                  ship_status: "",
                  search_key: "",
                };
                if (dates.end_date && dates.start_date) {
                  obj = { ...obj, ...dates };
                }
                setFilters((f) => ({
                  ...f,
                  ship_status: "",
                  search_key: "",
                }));
                dispatch(customerShipmentsList(obj));
              },
              isActive: filters.ship_status === "",
            },
            // { label: "PSA Cancelled", action: () => { } },
          ]}
          isDateFilter={true}
          exportComponent={
            <button
              disabled={shipment_list?.loading || !shipment_list?.data?.length}
              onClick={() => {
                let prods =
                  filters.ship_status === 3
                    ? shipment_list?.data?.filter(
                        // eslint-disable-next-line
                        (ele) =>
                          ele?.Preshipstatus === "P" &&
                          ele?.Vtweg === "42" &&
                          ele?.ShipNo
                      )
                    : shipment_list?.data;

                prods = prods?.map((ele) => ({
                  "Shipment ID": ele.ShipNo,
                  "Sales Order": ele.Sostring,
                  "Customer PO": ele.Custpostring,
                  "Delivered Quantity (Pcs)": parseInt(ele.DeliveredQty),
                  "Total Fill": parseFloat(ele.ZfillTot).toFixed(3),
                  ETD:
                    ele.EtdDate && !ele.EtdDate?.includes("0000")
                      ? moment(ele.EtdDate, "YYYYMMDD").format("MM/DD/YY")
                      : "-",
                  ETA:
                    ele.EtaDate && !ele.EtaDate?.includes("0000")
                      ? moment(ele.EtaDate, "YYYYMMDD").format("MM/DD/YY")
                      : "-",
                  "Pre-shipment advice": Preshipstatus[ele.Preshipstatus]
                    ? Preshipstatus[ele.Preshipstatus]
                    : "-",
                  "Shipment Status": ship_status_text[ele.ShipStatus]
                    ? ship_status_text[ele.ShipStatus]
                    : "-",
                  "Shipment Origin": ele.Werkscrtyname,
                  "Delivery Address": ele.Street,
                  "Container No": ele.Container,
                  "Vessel Name": ele.VesselNo,
                }));
                let csv = json2csv.parse(prods);
                var blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
                saveAs(blob, "ShipmentList.csv");
              }}
            >
              <DownloadOutlined color="#333" />
            </button>
          }
          rangePlaceholder={["ETD Start date", "ETD End date"]}
          options={[{ label: "All Dates", value: "all" }]}
          label={""}
          total_count={shipment_list?.data?.length}
          perPageLimit={shipment_list?.data?.length}
          isRange={true}
          callSearch={(search) => {
            let obj = {
              email: localStorage.getItem("email"),
            };
            if (dates.end_date && dates.start_date) {
              obj = { ...obj, ...dates };
            }
            dispatch(customerShipmentsList({ ...obj, search_key: search }));
            setFilters((f) => ({ ...f, search_key: search }));
          }}
          searchVal={filters.search_key || ""}
          onRangeChange={(val) => {
            let start_date = val?.[0] ? moment(val?.[0]) : null;
            let end_date = val?.[1] ? moment(val?.[1]) : null;
            if (val === null) {
              setDates({});
            } else {
              if (start_date && end_date) {
                setDates({
                  start_date,
                  end_date,
                });
              }
            }
          }}
        >
          <Table
            columns={columns}
            data={
              Array.isArray(shipment_list?.data)
                ? filters.ship_status === 3
                  ? shipment_list?.data?.filter(
                      // eslint-disable-next-line
                      (ele) =>
                        ele?.Preshipstatus === "P" &&
                        ele?.Vtweg === "42" &&
                        ele?.ShipNo
                    )
                  : shipment_list?.data
                : []
            }
            loading={shipment_list?.loading}
            action={false}
            scroll={tableScroll}
            actionWidth={8}
            onRowClick={(row) => {
              history.push("/shipment-detail", {
                do_number: row.DeliveryNo,
                do_numbers: row.do_numbers,
                shipment_no: row.ShipNo,
                filters,
                from: "shipments",
                order_type: row.Vtweg == "41" ? "ftl" : "fd",
              });
            }}
          />
        </TableWrap>
      </NavWrap>
    </div>
  );
};

export default Shipments;
